<script>

import IndividualStatusForm from './IndividualStatusForm/IndividualStatusForm.vue';
import DrSelect from '../components/DrSelect.vue';

export default {
    components: {
        IndividualStatusForm,
        DrSelect
    },
    data() {
        return {
            jurisdiction: '',
            dealingRep: '',
            dealingReps: [],
            investing_as: '',
            investorStatus: '',
            is_registered: '',
            amount: '',
            current_investment_in_issuer: ''
        }
    },
    methods: {
        canSelectDealingRep() {
            return this.jurisdiction !== '';
        },
        canSelectInvestor() {
            return this.dealingRep !== '';
        },
        canSelectInvestorStatus() {
            return this.investing_as !== '';
        },
        canSelectRegistration() {
            return this.investorStatus !== '' && this.investing_as === 'individual';
        },
        canEnterAmount() {
            return (
                this.canSelectRegistration() && this.is_registered !== ''
            ) || (
                !this.canSelectRegistration() && this.investorStatus !== ''
            );
        },
        canIndicateTotalInvestment() {
            return this.amount !== '';
        },
        canSubmit() {
            return this.current_investment_in_issuer !== ''
        }
    }
}
</script>
